import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import './DatePickInputer.css';
import classNames from 'classnames';
import moment from 'moment';
import listensToClickOutside from 'react-onclickoutside';
import { isEmpty } from 'lodash';

class DatePickInputer extends Component {
  constructor(props) {
    super(props);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    let {
      initialMonth,
      formater,
    } = this.props;

    formater = formater ? formater : 'YYYY/MM/DD';
    const momentObject = typeof(initialMonth) === 'string' ? moment(initialMonth, formater) : moment(initialMonth);

    if (this.props.allowEmpty) {
      initialMonth = isEmpty(initialMonth) === false ? momentObject.format(formater) : '';
    } else {
      initialMonth = (momentObject.isValid() && momentObject.format(formater)) || moment().format(formater);
    }

    // 預設最小日期為1753/01/01
    let minDateDefault = moment('1753-01-01').startOf('day').toDate();
    if (props.minDate && moment(props.minDate).startOf('day').toDate() > moment('1753-01-01').startOf('day').toDate()) {
      minDateDefault = moment(props.minDate).startOf('day').toDate();
    }
    // 預設最大日期為9999/12/31
    let maxDateDefault = moment('9999-12-31').startOf('day').toDate();
    if (props.maxDate && moment(props.maxDate).startOf('day').toDate() < moment('9999-12-31').startOf('day').toDate()) {
      maxDateDefault = moment(props.maxDate).startOf('day').toDate();
    }

    this.state = {
      isShowPicker: false,
      value: initialMonth,
      month: initialMonth === '' ? moment().toDate() : moment(initialMonth, formater).toDate(),
      placeholder: props.placeholder || 'YYYY/MM/DD',
      maxDate: maxDateDefault,
      minDate: minDateDefault,
      formater,
    };
  }

  componentWillReceiveProps(nextProps) {
    let {
      initialMonth,
      formater,
    } = nextProps;

    formater = formater ? formater : 'YYYY/MM/DD';
    const momentObject = typeof(initialMonth) === 'string' ? moment(initialMonth, formater) : moment(initialMonth);

    if (nextProps.allowEmpty) {
      initialMonth = isEmpty(initialMonth) === false ? momentObject.format(formater) : '';
    } else {
      initialMonth = (momentObject.isValid() && momentObject.format(formater)) || moment().format(formater);
    }

    // 預設最小日期為1753/01/01
    let minDateDefault = moment('1753-01-01').startOf('day').toDate();
    if (nextProps.minDate && moment(nextProps.minDate).startOf('day').toDate() > moment('1752-12-31').startOf('day').toDate()) {
      minDateDefault = moment(nextProps.minDate).startOf('day').toDate();
    }
    // 預設最大日期為9999/12/31
    let maxDateDefault = moment('9999-12-31').startOf('day').toDate();
    if (nextProps.maxDate && moment(nextProps.maxDate).startOf('day').toDate() < moment('10000-01-01').startOf('day').toDate()) {
      maxDateDefault = moment(nextProps.maxDate).startOf('day').toDate();
    }
    this.state = {
      isShowPicker: false,
      value: initialMonth,
      month: initialMonth === '' ? moment().toDate() : moment(initialMonth, formater).toDate(),
      placeholder: nextProps.placeholder || 'YYYY/MM/DD',
      maxDate: maxDateDefault,
      minDate: minDateDefault,
      formater,
    };
  }

  handleClickOutside() {
    this.setState({
      isShowPicker: false,
    });
  }

  handleTogglePicker(event) {
    event.preventDefault();
    this.setState({
      isShowPicker: !this.state.isShowPicker,
    });
  }

  handleDayClick(e, day, modifiers) {
    const { maxDate, minDate, formater } = this.state;
    const date = moment(day).startOf('day');
    if (maxDate && date > maxDate) {
      return;
    }

    if (minDate && date < minDate) {
      return;
    }

    this.setState({
      value: moment(day).format(formater),
      month: day,
      isShowPicker: false,
    });

    if (this.props.handleDayClick && typeof this.props.handleDayClick === 'function') {
      this.props.handleDayClick(e, moment(day).format(formater), modifiers);
    }
  }

  handleInputChange(e) {
    const { value } = e.target;
    this.setState({ value }, this.showCurrentDate);
  }

  handleKeyDown(e) {
    if (e.keyCode === 13) {
      // 按Enter時，寫入現在輸入的值，同Blur
      this.handleInputBlur.call(this, e);
    }
  }

  handleInputBlur(event) {
    const { maxDate, minDate, formater, value, month, modifiers } = this.state;
    const { allowEmpty, toMinDate } = this.props;
    if (allowEmpty && isEmpty(value)) {
      if (this.props.handleDayClick && typeof this.props.handleDayClick === 'function') {
        this.props.handleDayClick(event, null);
      }
      return;
    }

    let date = moment(value, formater).startOf('day');

    if (!date.isValid()
        || (maxDate && date.toDate() > maxDate)
        || (minDate && date.toDate() < minDate)
    ) {
      date = moment(month);
      if (toMinDate && !!minDate) date = moment(minDate);
      this.setState({
        value: date.format(formater),
      });
    }

    if (this.props.handleDayClick && typeof this.props.handleDayClick === 'function') {
      this.props.handleDayClick(event, date.format(formater), modifiers);
    }
  }
  showCurrentDate() {
    this.refs.daypicker.showMonth(this.state.month);
  }

  render() {
    const {
      value,
      isShowPicker,
      month,
      placeholder,
      maxDate,
      minDate,
    } = this.state;

    let {
      modifiers,
    } = this.props;
    const {
      disabled,
      readOnly,
      errorTipBorderStyle,
      giveWidth,
    } = this.props;

    modifiers = Object.assign({
      selected: day => DateUtils.isSameDay(day, month),
      disabled: (day) => {
        const date = moment(day).startOf('day').toDate();
        if (maxDate && date > maxDate) {
          return true;
        }
        if (minDate && date < minDate) {
          return true;
        }

        return false;
      },
    }, modifiers);

    const originStyle = {
      borderRadius: '5px 0px 0px 5px',
      width: giveWidth,
    };
    const Errortipborderstyle = Object.assign(originStyle, errorTipBorderStyle);
    return (
      <div
        className={classNames({
          'datePickInputer__container': true,
          'input-group': true,
        })}
      >
        <div
          className={classNames({
            'picker-container': true,
            'active': isShowPicker,
          })}
        >
          <DayPicker
            ref="daypicker"
            {...this.props}
            initialMonth={month}
            modifiers={ modifiers }
            onDayClick={ this.handleDayClick.bind(this) }
          />
        </div>
        <input
          style={this.props.errorTipBorderStyle ? Errortipborderstyle : originStyle}
          onBlur={this.handleInputBlur.bind(this)}
          type="text"
          ref="input"
          value={value}
          className="form-control"
          placeholder={placeholder}
          onChange={ this.handleInputChange.bind(this) }
          onFocus={ this.showCurrentDate.bind(this) }
          disabled={disabled}
          readOnly={readOnly}
          onKeyDown={this.handleKeyDown.bind(this)}
        />
        <div className="input-group-btn">
          <button
            className="btn btn-default"
            type="button"
            disabled={disabled}
            onClick={
              disabled || readOnly ?
              (e) => e.preventDefault() :
              this.handleTogglePicker.bind(this)
            }
          >
            <i className="fa fa-calendar"></i>
          </button>
        </div>
      </div>
    );
  }
}

DatePickInputer.propTypes = {
  initialMonth: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  formater: PropTypes.string,
  giveWidth: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  modifiers: PropTypes.object,
  handleDayClick: PropTypes.func,
  minDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  maxDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  errorTipBorderStyle: PropTypes.object,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  allowEmpty: PropTypes.bool,
  toMinDate: PropTypes.bool,
};

export default listensToClickOutside(DatePickInputer);



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/components/DatePickInputer.js
 **/